export class CommunicationModel {
  constructor(data: any) {
  }
}
